/**
 * Hornaut-Kopf (Marke, Bestands-Asset `hornaut-kopf-ohne-ring-128.png`): Absender von KI-Aussagen (W104 A, AW-076).
 * Kein Icon-Ersatz: der Kopf steht nie ohne Namen/Label daneben (dekorativ, `alt=""`) und nur in `.ai-gated`-Inhalt
 * bzw. an `.ai-mark`-Auslösern (Gegen-Test `ki-violett-gegentest.test.ts`). Bei KI aus erscheint er nicht.
 * Eine gemeinsame Quelle für Tour-Begleiter, KiAussage, KiKarte und HornautKnopf.
 */
export const HORNAUT_KOPF_AVATAR = "/assets/hornaut/hornaut-kopf-ohne-ring-128.png";
